<template>
  <ion-card ref="card" class="ion-margin" v-if="Object.keys(chartData).length">
    <ion-card-header>
      <ion-card-subtitle>
        {{ subTitle }}
      </ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <div class="card-main">
        <div class="chart">
          <Doughnut
            :options="chartOptions"
            :data="chartData"
          />
          <p id="data">{{ data }}</p>
        </div>
        <div></div>
        <ion-icon :icon="icon"/>
      </div>
      <div class="card-footer ion-text-center ion-margin-top">{{ additionalInfo }}</div>
    </ion-card-content>
  </ion-card>
</template>

<script setup lang="ts">
import { IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonIcon } from "@ionic/vue";
import { defineProps, onMounted, ref } from "vue";
import { Doughnut } from 'vue-chartjs'
import { useMotion } from "@vueuse/motion";

import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
ChartJS.register(ArcElement, Tooltip, Legend)

const props = defineProps({
  subTitle: {
    type: String,
    required: true
  },
  title: {
    type: String,
    required: false
  },
  data: {
    type: String,
    required: true
  },
  icon: {
    type: String,
    required: false
  },
  additionalInfo: {
    type: String,
    required: false
  }
})

let chartData = ref({}) as any
let chartOptions = ref({})
let primaryColor = ref("")
const card = ref()

let style = window.getComputedStyle(document.body)

onMounted(() => {
  primaryColor.value = style.getPropertyValue('--ion-color-primary')

  const value = props.data.includes("%") ? props.data.replace("%", "") : props.data

  chartData.value = {
    labels: "",
    datasets: [{
      label: "",
      data: [100 - +value, +value],
      backgroundColor: ["#676767", "transparent"],
      borderWidth: value == "0" ? "1" : "0",
      borderColor: ["", primaryColor.value]
    }]
  }

  chartOptions.value = {
    responsive: true,
    cutout: "70%",  // cutout from the center to control the chart width
    events: []  // to remove hover effect and remove tooltip(for removing tooltip we can also use plugins: { tooltip: { enabled: false } })
  }
})

const { variant } = useMotion(card, {
  initial: {
    opacity: 0,
    y: 100
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 300,
      type: 'keyframes',
      ease: 'easeIn',
    },
  }
})
</script>

<style scoped>
.chart {
  flex: 0.75;
  display: grid;
  place-items: center;
  height: 160px;
}

canvas, #data {
  grid-area: 1 / 1 / 1  / 1;
  font-size: 24px;
}

.card-main {
  align-items: center;
}

.card-footer {
  justify-items: center;
  font-size: 16px;
  border-top: 1px solid;
}

</style>